import React, { useEffect, useRef } from 'react';
import { Loader } from 'components';

interface Props {
  url: string;
  elements: { name: string; value: string }[];
}

export const PayboxForm: React.FC<Props> = ({ url, elements }) => {
  const ref = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    // submit form on load
    if (url && elements.length > 0) {
      ref.current?.submit();
    }
  }, [url, elements, ref]);

  return elements.length > 0 ? (
    <form method="POST" action={url} ref={ref}>
      {elements.map(el => {
        return <input type="hidden" key={el.name} name={el.name} value={el.value} />;
      })}
      <Loader />
    </form>
  ) : null;
};
